var _style, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 63,
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .circle {\n      stroke-dasharray: 2000;\n      stroke-dashoffset: 2000;\n      animation: stroke 1s ease-out forwards;\n    }\n    .mark-star {\n      transform: scale(0);\n      transform-origin: center;\n      animation: zoom-in 400ms ease-out 150ms forwards;\n    }\n    @keyframes stroke {\n      to {\n        stroke-dashoffset: 0;\n      }\n    }\n    @keyframes zoom-in{\n        to{\n          transform: scale(1)\n        }\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#41B661"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 31,
    cy: 31,
    r: 28,
    stroke: "#41B661",
    fill: "none",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "mark-star",
    d: "m47.899 22.436-17.8 17.773-3.626 3.678-3.626-3.652 3.626-3.627 17.8-17.798 3.626 3.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mark-star",
    d: "m30.098 40.21-3.627 3.678-3.626-3.652-8.745-8.72 3.652-3.626 12.346 12.32ZM19.426 17.19l2.572-1.287 1.286-2.572 1.286 2.572 2.572 1.287-2.572 1.286-1.286 2.572-1.286-2.572-2.572-1.286ZM40.002 44.196l1.723-.848.849-1.724.849 1.724 1.723.848-1.723.85-.849 1.723-.849-1.724-1.723-.849Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h62v62H0z",
    transform: "translate(0 .302)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e8ff2c028fdceabcb7d208500ccd2606.svg";
export { ForwardRef as ReactComponent };